import type { MenubarDesignTokens } from '@primeuix/themes/types/menubar';

/**
 * Menubar component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/menubar/index.ts
 *
 * Component documentation:
 * https://primeng.org/menubar
 */
export const menubarComponentTokens: Partial<MenubarDesignTokens> = {
  item: {
    padding: '0.75rem',
  },
};

